import React from 'react';
import {
  Button,
  Divider,
  Icon,
  Popconfirm,
  Skeleton,
  Table,
  Tag,
  Typography
} from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ContentCustom } from '../../components';
import { categoryTypesColors } from '../../utils';

const { Column } = Table;
const iconSize = '18px';

const InvoiceType = ({
  isLoading,
  invoiceTypes,
  pagination1,
  setPagination1,
  editInvoiceType,
  del
}) => {
  const { t } = useTranslation();
  return (
    <ContentCustom marginTop={8}>
      <Typography.Title level={4}>
        {t('catalog.list.invoiceTypes.title')}
      </Typography.Title>
      <Skeleton
        active
        title={false}
        loading={isLoading}
        paragraph={{
          rows: 8,
          width: [
            '100%',
            '100%',
            '100%',
            '100%',
            '100%',
            '100%',
            '100%',
            '100%'
          ]
        }}
      >
        <Table
          rowClassName="rowStyle"
          dataSource={invoiceTypes}
          loading={isLoading}
          pagination={pagination1}
          onChange={(page) => {
            setPagination1(page);
          }}
          rowKey="_id"
          scroll={{ x: 800 }}
        >
          <Column
            title={t('catalog.list.invoiceTypes.typeName')}
            dataIndex="label"
            align="center"
            sorter={(a, b) => a.label.localeCompare(b.label)}
            sortDirections={['ascend', 'descend']}
            render={(label) => <Typography>{label}</Typography>}
          />
          <Column
            title={t('catalog.list.invoiceTypes.invoiceType')}
            dataIndex="category"
            align="center"
            sorter={(a, b) => a.category.localeCompare(b.category)}
            sortDirections={['ascend', 'descend']}
            render={(label) => (
              <Tag color={categoryTypesColors[label]}>{label}</Tag>
            )}
          />
          <Column
            title={t('users.list.column.actions')}
            key="action"
            fixed="right"
            render={({ _id }) => (
              <span>
                <Button type="link" onClick={() => editInvoiceType(_id)}>
                  <Icon type="edit" style={{ fontSize: iconSize }} />
                </Button>
                <Divider type="vertical" />
                <Popconfirm
                  title={t('catalog.list.column.action.delete.title')}
                  okText={t('catalog.list.column.action.delete.ok')}
                  cancelText={t('catalog.list.column.action.delete.cancel')}
                  onConfirm={() => del(_id, 'invoicetypes')}
                  icon={<Icon type="warning" />}
                >
                  <Icon
                    style={{ color: 'red', fontSize: iconSize }}
                    type="delete"
                  />
                </Popconfirm>
              </span>
            )}
          />
        </Table>
      </Skeleton>
    </ContentCustom>
  );
};

InvoiceType.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  invoiceTypes: PropTypes.arrayOf().isRequired,
  pagination1: PropTypes.shape({}).isRequired,
  setPagination1: PropTypes.func.isRequired,
  editInvoiceType: PropTypes.func.isRequired,
  del: PropTypes.func.isRequired
};

export default InvoiceType;
